import rest from "@/restUtils";
import utils from "@/utils";

const path = '/article';

export default {
    namespace: true,
    state: {},

    actions: {
        async listArticles(context, [page, size]) {
            try {
                let articles = await rest.doGet(`${path}?page=${page || 0}${!!size ? '&size=' + size : ''}`);

                if (!!articles && articles.length > 0) {
                    articles.forEach(article => {
                        let date = utils.convertDateToUTC(new Date(article.date));
                        Object.assign(article, {date});
                    });
                }

                return articles;
            } catch (error) {
                alert(error.response.data.message);
            }
        },

        async getArticle(context, id) {
            try {
                let article = await rest.doGet(`${path}?id=${id}`);

                let date = utils.convertDateToUTC(new Date(article.date));
                Object.assign(article, {date});

                return article;
            } catch (error) {
                alert(error.response.data.message);
            }
        },

        async getArticleByCode(context, code) {
            try {
                let article = await rest.doGet(`${path}?code=${code}`);

                let date = utils.convertDateToUTC(new Date(article.date));
                Object.assign(article, {date});

                return article;
            } catch (error) {
                alert(error.response.data.message);
            }
        },

        async createArticle(context, payload) {
            try {
                let article = await rest.doPost(path, payload);
                return article;
            } catch (error) {
                alert(error.response.data.message);
            }
        },

        async updateArticle(context, [id, payload]) {
            try {
                let article = await rest.doPost(`${path}?id=${id}`, payload);
                return article;
            } catch (error) {
                alert(error.response.data.message);
            }
        },

        async deleteArticle(context, id) {
            let success;
            try {
                await rest.doDelete(`${path}?id=${id}`);
                success = true;
            } catch (error) {
                success = false;
                alert(error.response.data.message);
            }
            return success;
        },

        async deleteArticleImage(context, id) {
            let success;
            try {
                await rest.doDelete(`${path}/image?id=${id}`);
                success = true;
            } catch (error) {
                success = false;
                alert(error.response.data.message);
            }
            return success;
        }
    },

    mutations: {},

    getters: {}
}